import React, { useState } from "react";

import {
    Modal,
    Box,
    TextField,
    Button,
    IconButton,
    Typography,
    InputAdornment,
    MenuItem,
    ToggleButton,
    ToggleButtonGroup,
    Checkbox
} from "@mui/material";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";

import CloseIcon from "@mui/icons-material/Close";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import { MascaraTelefone } from "../../utils/MascaraTelefone";
import axios from "axios";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

export default function ModalHome(props) {

    const [nome, setNome] = useState("");
    const [segmento, setSegmento] = useState("selecione");
    const [whatsapp, setWhatsapp] = useState("");
    const [tipoContato, setTipoContato] = useState("");
    const [msgErro, setMsgErro] = useState("");
    const [open, setOpen] = useState(false);
    const [agree, setAgree] = useState(false);

    const handleSubmit = async () => {
        if (!nome || segmento === "selecione" || !whatsapp || !tipoContato || !agree) {
            setMsgErro("Por favor, preencha todos os campos e aceite os termos.");
            return;
        }

        if (whatsapp.replace(/\D/g, "").length < 10) {
            setMsgErro("Por favor, insira um número de WhatsApp válido.");
            return;
        }

        try {
            setOpen(true);
            await axios.post(`${process.env.REACT_APP_API_URL}/receberFormularioContato`, {
                nome,
                segmento,
                whatsapp,
                tipoContato
            });
            setNome("");
            setSegmento("selecione");
            setWhatsapp("");
            setTipoContato("");
            setMsgErro("");
            setOpen(false);
            props.setOpenModalHome(false);
        } catch (error) {
            setMsgErro("Ocorreu um erro ao enviar o formulário. Por favor, tente novamente.");
            setOpen(false);
        }
    };

    return (
        <>
            <Modal
                open={props.openModalHome}
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "85%",
                        maxWidth: "560px",
                        background:
                            "linear-gradient(180deg, #0B0B0B 0%, #111111 100%)",
                        border: "1px solid rgba(255,255,255,0.08)",
                        borderRadius: "28px",
                        boxShadow: "0px 20px 60px rgba(0,0,0,0.45)"
                    }}
                >

                    {/* HEADER */}
                    <Box
                        sx={{
                            position: "relative",
                            padding: "32px 32px 24px 32px",
                            background:
                                "linear-gradient(135deg, #111 0%, #1A1A1A 100%)",
                            borderBottom: "1px solid rgba(255,255,255,0.06)"
                        }}
                    >

                        {/* Glow */}
                        <Box
                            sx={{
                                position: "absolute",
                                width: 220,
                                height: 220,
                                background: "#00E676",
                                opacity: 0.08,
                                borderRadius: "50%",
                                filter: "blur(60px)",
                                top: -120,
                                right: -100
                            }}
                        />

                        <IconButton
                            onClick={() => props.setOpenModalHome(false)}
                            sx={{
                                position: "absolute",
                                top: 18,
                                right: 18,
                                color: "#FFF",
                                background: "rgba(255,255,255,0.05)",

                                "&:hover": {
                                    background: "rgba(255,255,255,0.1)"
                                }
                            }}
                        >
                            <CloseIcon />
                        </IconButton>

                        <Typography
                            sx={{
                                color: "#00E676",
                                fontSize: "14px",
                                fontWeight: 700,
                                letterSpacing: "1px",
                                textTransform: "uppercase",
                                marginBottom: "10px"
                            }}
                        >
                            Contblack
                        </Typography>

                        <Typography
                            sx={{
                                color: "#FFF",
                                fontSize: {
                                    xs: "28px",
                                    md: "34px"
                                },
                                fontWeight: 800,
                                lineHeight: 1.1,
                                marginBottom: "14px"
                            }}
                        >
                            Fale com um especialista
                        </Typography>

                        {/* <Typography
                            sx={{
                                color: "rgba(255,255,255,0.72)",
                                fontSize: "15px",
                                lineHeight: 1.6
                            }}
                        >
                            Descubra como economizar tempo, pagar menos impostos
                            e ter uma contabilidade realmente estratégica.
                        </Typography> */}
                    </Box>

                    {/* FORM */}
                    <Box
                        sx={{
                            padding: "28px 32px 32px 32px",
                            display: "flex",
                            flexDirection: "column",
                            gap: 2
                        }}
                    >

                        <TextField
                            name="nome"
                            placeholder="Seu nome"
                            size="small"
                            value={nome}
                            onChange={(e) => {
                                const value = e.target.value.replace(/[^A-Za-zÀ-ÿ\s]/g, "");
                                setNome(value);
                                setMsgErro("");
                            }}
                            // so permite letras e espaços
                            fullWidth
                            variant="outlined"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <PersonOutlineIcon
                                            sx={{
                                                color: "rgba(255,255,255,0.45)"
                                            }}
                                        />
                                    </InputAdornment>
                                )
                            }}
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    borderRadius: "14px",
                                    background: "rgba(255,255,255,0.04)",
                                    color: "#FFF",

                                    "& fieldset": {
                                        borderColor: "rgba(255,255,255,0.08)"
                                    },

                                    "&:hover fieldset": {
                                        borderColor: "#00E676"
                                    },

                                    "&.Mui-focused fieldset": {
                                        borderColor: "#00E676"
                                    }
                                },

                                "& input::placeholder": {
                                    color: "rgba(255,255,255,0.5)",
                                    opacity: 1
                                }
                            }}
                        />

                        <TextField
                            select
                            name="perfil"
                            size="small"
                            value={segmento}
                            onChange={(e) => {
                                setSegmento(e.target.value);
                                setMsgErro("");
                            }}
                            fullWidth
                            variant="outlined"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <WorkOutlineIcon
                                            sx={{
                                                color: "rgba(255,255,255,0.45)"
                                            }}
                                        />
                                    </InputAdornment>
                                )
                            }}
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    borderRadius: "14px",
                                    background: "rgba(255,255,255,0.04)",
                                    color: "#FFF",

                                    "& fieldset": {
                                        borderColor: "rgba(255,255,255,0.08)"
                                    },

                                    "&:hover fieldset": {
                                        borderColor: "#00E676"
                                    },

                                    "&.Mui-focused fieldset": {
                                        borderColor: "#00E676"
                                    },

                                    "& .MuiSelect-icon": {
                                        color: "rgba(255,255,255,0.5)"
                                    }
                                },

                                "& .MuiInputBase-input": {
                                    color: "#FFF"
                                }
                            }}
                        >
                            <MenuItem value="selecione" disabled>Selecione seu perfil</MenuItem>
                            <MenuItem value="Freela">Freela</MenuItem>
                            <MenuItem value="Creators">Creators</MenuItem>
                            <MenuItem value="Alt Model">Alt models</MenuItem>
                            <MenuItem value="Infoprodutores">Infoprodutores</MenuItem>
                            <MenuItem value="MEIS">MEIS</MenuItem>
                            <MenuItem value="Anywhere office">Anywhere office</MenuItem>
                            <MenuItem value="Digital influencer">Digital influencer</MenuItem>
                            <MenuItem value="Gamers">Gamers</MenuItem>
                            <MenuItem value="Outro">Outro</MenuItem>
                        </TextField>
                        <TextField
                            size="small"
                            name="whatsapp"
                            type="tel"
                            placeholder="Seu WhatsApp"
                            value={whatsapp}
                            onChange={(e) => {
                                setWhatsapp(MascaraTelefone(e.target.value));
                                setMsgErro("");
                            }}
                            fullWidth
                            variant="outlined"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <WhatsAppIcon
                                            sx={{
                                                color: "#00E676"
                                            }}
                                        />
                                    </InputAdornment>
                                )
                            }}
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    borderRadius: "14px",
                                    background: "rgba(255,255,255,0.04)",
                                    color: "#FFF",

                                    "& fieldset": {
                                        borderColor: "rgba(255,255,255,0.08)"
                                    },

                                    "&:hover fieldset": {
                                        borderColor: "#00E676"
                                    },

                                    "&.Mui-focused fieldset": {
                                        borderColor: "#00E676"
                                    }
                                },

                                "& input": {
                                    color: "#FFF"
                                },

                                "& input::placeholder": {
                                    color: "rgba(255,255,255,0.5)",
                                    opacity: 1
                                }
                            }}
                        />

                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 1
                            }}
                        >

                            <Typography
                                sx={{
                                    color: "rgba(255,255,255,0.75)",
                                    fontSize: "14px",
                                    fontWeight: 600
                                }}
                            >
                                Como prefere nosso contato?
                            </Typography>

                            <ToggleButtonGroup
                                exclusive
                                fullWidth
                                value={tipoContato}
                                onChange={(e, value) => {
                                    if (value !== null) {
                                        setTipoContato(value);
                                        setMsgErro("");
                                    }
                                }}
                                sx={{
                                    gap: 1,
                                    background: "transparent"
                                }}
                            >

                                <ToggleButton
                                    value="mensagem"
                                    sx={{
                                        flex: 1,
                                        height: "40px",
                                        borderRadius: "14px !important",
                                        border: "1px solid rgba(255,255,255,0.08) !important",
                                        background: "rgba(255,255,255,0.04)",
                                        color: "#FFF",
                                        textTransform: "none",
                                        fontWeight: 700,
                                        gap: 1,

                                        "&.Mui-selected": {
                                            background:
                                                "linear-gradient(135deg, #00E67620 0%, #00C85320 100%)",
                                            border: "1px solid #00E676 !important",
                                            color: "#00E676"
                                        },

                                        "&:hover": {
                                            background: "rgba(255,255,255,0.07)"
                                        }
                                    }}
                                >
                                    <ChatBubbleOutlineIcon />
                                    Mensagem
                                </ToggleButton>

                                <ToggleButton
                                    value="ligacao"
                                    sx={{
                                        flex: 1,
                                        height: "40px",
                                        borderRadius: "14px !important",
                                        border: "1px solid rgba(255,255,255,0.08) !important",
                                        background: "rgba(255,255,255,0.04)",
                                        color: "#FFF",
                                        textTransform: "none",
                                        fontWeight: 700,
                                        gap: 1,

                                        "&.Mui-selected": {
                                            background:
                                                "linear-gradient(135deg, #00E67620 0%, #00C85320 100%)",
                                            border: "1px solid #00E676 !important",
                                            color: "#00E676"
                                        },

                                        "&:hover": {
                                            background: "rgba(255,255,255,0.07)"
                                        }
                                    }}
                                >
                                    <CallOutlinedIcon />
                                    Ligação
                                </ToggleButton>

                            </ToggleButtonGroup>
                        </Box>
                        {msgErro && (
                            <Typography
                                sx={{
                                    color: "#FF1744",
                                    fontSize: "14px",
                                    marginTop: "4px"
                                }}
                            >
                                {msgErro}
                            </Typography>
                        )}
                        {/* // chebox para aceitar politica de privacidade
                        //  */}
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={agree}
                                        onChange={(e) => setAgree(e.target.checked)}
                                        sx={{
                                            color: "rgba(255,255,255,0.35)",

                                            "&.Mui-checked": {
                                                color: "#00E676"
                                            }
                                        }}
                                    />
                                }
                                label={<span style={{ color: "rgba(255,255,255,0.75)", fontSize: "14px" }}>
                                    Ao clicar no botao "Quero ser contatado", voce esta de acordo e autoriza o contato
                                </span>}
                            />
                        </FormGroup>
                        <Button
                            variant="contained"
                            onClick={handleSubmit}
                            endIcon={<ArrowForwardIcon />}
                            disabled={open}
                            sx={{
                                height: "56px",
                                borderRadius: "14px",
                                marginTop: "8px",
                                background:
                                    "linear-gradient(135deg, #00E676 0%, #00C853 100%)",
                                color: "#000",
                                fontSize: "15px",
                                fontWeight: 800,
                                textTransform: "none",
                                boxShadow: "0px 10px 30px rgba(0,230,118,0.25)",

                                "&:hover": {
                                    background:
                                        "linear-gradient(135deg, #00f57f 0%, #00d45a 100%)"
                                }
                            }}
                            fullWidth
                        >
                            {open ? "Enviando..." : "Quero ser contatado"}
                        </Button>

                        <Typography
                            sx={{
                                color: "rgba(255,255,255,0.4)",
                                fontSize: "12px",
                                textAlign: "center",
                                marginTop: "4px",
                                lineHeight: 1.5
                            }}
                        >
                            Seus dados estão seguros e não serão compartilhados.
                        </Typography>
                    </Box>
                </Box>
            </Modal>
        </>
    );
}